var exports = {
  "de": "PopoverContainer__-6zl5y",
  "Xs": "PopoverContainerDesktop__fugsZ9",
  "rq": "PopoverContainerMobile__-k8xBc",
  "hl": "PopoverContent__ATJRNx",
  "DZ": "Heading__7oSskg",
  "Rd": "PreviewLabel__44UECa",
};

module.exports = exports;
